import {
  IGeometryModel,
  MarkerModelBase,
} from '@types-custom/models/business/marker.model';
import { Icon } from '@types-custom/models/ui/icon-model';


export interface IPropsParkingLoadingZoneModel {
  id?: string;
  name: string;
  popupinfo: string;
  type: string;
  icon?: Icon;
}

export class ParkingLoadingZoneModel extends MarkerModelBase {
  static className = 'ParkingLoadingZoneModel';
  classProperties: IPropsParkingLoadingZoneModel;

  constructor(props: IPropsParkingLoadingZoneModel, geometry: IGeometryModel) {
    super(geometry, ParkingLoadingZoneModel.className);
    this.classProperties = props;
  }
}
